import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { ReactNode } from 'react';
import AnchorLinkComponent from '../../../AnchorLink';

export type AnchorLinkProps = StructuredContentDocument<{
  target: string;
  children: ReactNode;
}>;

export const AnchorLink = ({ props: { children, target } }: AnchorLinkProps) => {
  return (
    <AnchorLinkComponent target={target} scrollTopMargin="100px">
      {children}
    </AnchorLinkComponent>
  );
};
